import { Controller } from "@hotwired/stimulus"

// «Verifica il metodo» (MetodoPagamento di components/rendicontazione/Pagamenti.js): il pulsante si attiva con il metodo
// scelto, l'evidenza di almeno 5 caratteri e la nota di almeno 10 (senza gli spazi ai lati, come trim() dell'originale).
export default class extends Controller {
  static targets = ["metodo", "evidenza", "nota", "conferma"]

  connect() { this.controlla() }

  controlla() {
    this.confermaTarget.disabled = !(this.metodoTarget.value && this.evidenzaTarget.value.trim().length >= 5 && this.notaTarget.value.trim().length >= 10)
  }
}
